import { render, staticRenderFns } from "./editModeCoordinate.vue?vue&type=template&id=bb5fcd2c&scoped=true&"
import script from "./editModeCoordinate.vue?vue&type=script&lang=js&"
export * from "./editModeCoordinate.vue?vue&type=script&lang=js&"
import style0 from "./editModeCoordinate.vue?vue&type=style&index=0&id=bb5fcd2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5fcd2c",
  null
  
)

export default component.exports